// utils/telegramUrlGenerator.js
export const generateTelegramUrl = (phoneNumber, message) => {
    const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  
    return isMobile
      ? `https://t.me/${cleanedPhoneNumber}?text=${encodeURIComponent(message)}`
      : `https://web.telegram.org/#/im?p=@${cleanedPhoneNumber}&text=${encodeURIComponent(message)}`;
  };
    